// extracted by mini-css-extract-plugin
export default {"form":"ActivationExpiredForm_form__1YdL0","submitButton":"ActivationExpiredForm_submitButton__n3xFh","centered":"ActivationExpiredForm_centered__+58VB"};